import React from 'react';
import renderHTML from 'react-render-html';

const TrustedSection = ({ content }) => {
	return (
		<section className="row overview">
			<div className="col">
				<h2>Overview</h2>
				<p>{ renderHTML(content) }</p>
			</div>
		</section>
	);
};

export default TrustedSection;


// WEBPACK FOOTER //
// ./src/pages/category/common/TrustedSection.js